import { useEffect, useState } from 'react'
import useFirstRender from '../../hooks/FirstRender';
import LoadMore from '../../components/common/LoadMore';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useApiProgress } from '../../hooks/ApiProgress';
import { ENTITY_IS_IN_USE_MESSAGE, EXCEL_VALIDATION_MESSAGE, PRODUCT_TYPES } from '../../utils/constants';
import readXlsxFile, { readSheetNames } from 'read-excel-file';
import { toast } from 'react-toastify';
import Input from '../../components/Input';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import Button from '../../components/Button';
import { GoPlus } from 'react-icons/go';
import DeleteModal from '../../components/DeleteModal';
import { PRODUCT_COLLECTION_PATH, deleteProductCollection, getPageProductCollections } from '../../api/productCollectionApi';
import { translateProductType } from '../../utils/translator';
import { pageModel } from '../../utils/model';
import { setCollectionSearchParamsAction } from '../../redux/feature/searchParamsSlice';
import ProductTypePicker from '../../components/product/ProductTypePicker';
import { FaEye } from "react-icons/fa";
import { RiFileExcel2Fill } from 'react-icons/ri';
import { uploadProductExcelFile } from '../../api/productApi';
import { formatNumber } from '../../utils/functions';

const ProductListPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const nav = useNavigate()
    const dispatch = useDispatch()
    const [collectionPage, setCollectionPage] = useState(pageModel)
    const pendingApiCall = useApiProgress('get', `${PRODUCT_COLLECTION_PATH}/page`, false)
    const pendingApiCallDelete = useApiProgress('delete', `${PRODUCT_COLLECTION_PATH}`, false)
    const searchParams = useSelector(state => state.searchParams.collection)

    const [isOpen, setIsOpen] = useState(false)
    const [deleteId, setDeleteId] = useState(undefined)
    const [searchTimer, setSearchTimer] = useState();

    useEffect(() => {
        loadCollections({ size: 20, page: collectionPage.number, ...searchParams })
    }, [])

    const onLoadMore = () => {
        if (!collectionPage.last) {
            loadCollections({ ...searchParams, page: collectionPage.number + 1 })
        }
    }

    useEffect(() => {
        !isFirstRender && searching({ ...searchParams, page: 0 })
    }, [searchParams])

    const loadCollections = (params) => {
        !pendingApiCall &&
            getPageProductCollections(params)
                .then(res => {
                    setCollectionPage(prevState => ({ ...res.data, content: [...prevState.content, ...res.data.content] }))
                })
    }

    const searching = async (params) => {
        if (searchTimer) clearTimeout(searchTimer);
        let timer = setTimeout(() => {
            getPageProductCollections(params)
                .then(res => {
                    setCollectionPage(res.data)
                })
        }, 500);
        setSearchTimer(timer);
    }

    const onClickDelete = () => {
        deleteProductCollection(deleteId)
            .then(res => {
                setIsOpen(false)
                setCollectionPage(prevState => ({ ...prevState, content: prevState.content.filter(c => c.id !== res.data.id) }))
                toast.success('Silindi')
            }).catch(err => {
                toast.error(ENTITY_IS_IN_USE_MESSAGE)
            })
    }

    const uploadExcelFile = async (event) => {
        const file = event.target.files[0];
        if (!Boolean(file)) return;
        const sheets = await readSheetNames(file);
        let rows;
        for (const sheet of sheets) {
            rows = await readXlsxFile(file, { sheet });
            rows.shift();
        }
        const items = []
        for (const row of rows) {
            items.push({
                productCode: row[0],
                productName: row[1],
                type: row[2],
                hasVariations: row[3],
                colorCode: row[4],
                weightCode: row[5],
                patternCode: row[6],
                description: row[7]
            })
        }
        uploadProductExcelFile(items)
            .then(res => {
                //loadCollections({ size: 20, page: 0 })
                toast.success("Kayıtlar yüklendi")
            }).catch(err => {
                toast.error(EXCEL_VALIDATION_MESSAGE)
            })
    }

    return (
        <div>
            <div className='mb-1 border-b border-zinc-300'>
                <label className='text-2xl'>
                    ÜRÜNLER
                </label>
            </div>
            <div className='flex gap-x-2 py-2 sticky top-0 bg-zinc-50'>
                <Button
                    text={<label className='flex items-center gap-x-1'><GoPlus />Yeni Ürün</label>}
                    variant='green'
                    onClick={() => nav('/product/add')}
                />
                {/* <label
                    className='bg-emerald-700 hover:bg-emerald-800 disabled:bg-emerald-500 flex items-center gap-x-1 px-2 py-1 text-white text-md rounded-sm'
                    htmlFor='excel-upload'
                >
                    <RiFileExcel2Fill />
                    <span> Excel Yükle</span>
                </label> */}
                {/* <label
                    className='bg-emerald-700 hover:bg-emerald-800 disabled:bg-emerald-500 flex items-center gap-x-1 px-2 py-1 text-white text-md rounded-sm'
                    htmlFor='excel-download'
                    onClick={downloadExcelFile}
                >
                    <FaCloudDownloadAlt />
                    <span> Excel İndir</span>
                </label>
                <input className='hidden' id='excel-upload' type='file' accept='.xls, .xlsx' onChange={e => uploadExcelFile(e)} /> */}
            </div>
            <table className='w-full text-left text-zinc-900 mb-10 text-sm'>
                <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50'>
                    <tr>
                        <th className='p-2 w-1/12'>Id</th>
                        <th className='p-2 w-3/12'>Ürün Kodu</th>
                        <th className='p-2 w-3/12'>Ürün Adı</th>
                        <th className='p-2 w-1/12'>Ürün Tipi</th>
                        <th className='p-2 w-1/12'>Varyasyon</th>
                        <th className='p-2 w-1/12'>Stok (metre)</th>
                        {/* <th className='p-2 w-1/12'>Ort. Maliyet (USD/m)</th> */}
                        <th className='p-2 w-1/12'>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className='border-b items-center sticky top-20 bg-zinc-50'>
                        <td className='px-2'>
                            <Input
                                name="id"
                                placeholder='Id...'
                                value={searchParams.id}
                                onChange={e => dispatch(setCollectionSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="code"
                                placeholder='Ürün kodu...'
                                value={searchParams.code}
                                onChange={e => dispatch(setCollectionSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="name"
                                placeholder='Ürün adı...'
                                value={searchParams.name}
                                onChange={e => dispatch(setCollectionSearchParamsAction({ key: e.target.name, value: e.target.value }))}
                            />
                        </td>
                        <td>
                            <ProductTypePicker
                                className='text-xs'
                                value={searchParams.type}
                                onChange={(type) => dispatch(setCollectionSearchParamsAction({ key: "type", value: type }))}
                                text={translateProductType(searchParams.type) || 'Ürün tipi seçin'}
                                items={PRODUCT_TYPES}
                            />
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    {
                        collectionPage.content.map((collection, index) => (
                            <tr key={index} className='border-b items-center hover:bg-violet-100 duration-150'>
                                <td className='p-2'># {collection.id} </td>
                                <td className='p-2'>{collection.code} </td>
                                <td className='p-2'>{collection.name}</td>
                                <td className='p-2'>{translateProductType(collection.type)}</td>
                                <td className='p-2'>{collection.hasVariation ? `${collection.totalVariations} adet` : 'Yok'} </td>
                                <td className='p-2'>{formatNumber(collection.quantityOnHand)} m</td>
                                {/* <td className='p-2'>{collection.averageCost}</td> */}
                                <td className='p-2 items-center'>
                                    <div className='flex gap-x-3'>
                                        <span className='cursor-pointer hover:scale-125 hover:text-yellow-600 duration-150' onClick={() => nav(`/product/${collection.id}`)}>
                                            <FaEye />
                                        </span>
                                        <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => nav(`/product/edit/${collection.id}`)}>
                                            <AiFillEdit />
                                        </span>
                                        <span
                                            className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                            onClick={() => {
                                                setIsOpen(true)
                                                setDeleteId(collection.id)
                                            }}
                                        >
                                            <AiFillDelete />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <LoadMore page={collectionPage} pending={pendingApiCall} onLoadMore={onLoadMore} />
            <DeleteModal
                isOpen={isOpen}
                closeModal={() => setIsOpen(false)}
                onClick={onClickDelete}
                pendingApiCall={pendingApiCallDelete}
            />
        </div >
    )
}

export default ProductListPage